<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submitLocal)">
        <CRow>
            <CCustomSearchableInput
                col="12" md="6"
                vid="store_id"
                :name="$t('store._')"
                v-model="conversion.store_id"
                required
                rules="required"
                :items="stores"
                addWrapperClasses="mb-0"
            />
            <CCustomSearchableInput
                col="12" md="6"
                vid="user_id"
                :name="$t('user._')"
                v-model="conversion.user_id"
                required
                rules="required"
                :items="users"
                addWrapperClasses="mb-0"
            />
            <CCustomInput
                v-model="conversion.order_id"
                sm="12" md="6"
                vid="order_id"
                :name="$t('conversion.external_id')"
                rules="required"
                required
                ltr
            />
            <CCustomInput
                v-model="conversion.amount"
                sm="12" md="6"
                vid="amount"
                :name="$t('conversion.amount')"
                rules="required"
                type="number"
                required
                ltr
            />
            <CCustomInput
                v-model="conversion.coupon"
                sm="12" md="6"
                vid="coupon"
                :name="$t('coupon._')"
                ltr
            />
            <CRow class="mt-3">
                <CButton @click="addProductRow" color="behance" class="btn-sm d-block mfs-auto mfe-2 mb-2"><FaIcon icon="plus" /></CButton>
                <CDataTable
                    class="col-12 px-0"
                    :items="conversion.products"
                    :fields="$dataTableFieldsMaker(productsFields)"
                >
                    <template #pid="{item}">
                        <td class="ltr">
                            <CInput addInputClasses="small" v-model="item.pid" />
                        </td>
                    </template>

                    <template #name-header>
                        {{ $t('conversion.product_name') }}<span class="text-danger">*</span>
                    </template>
                    <template #name="{item}">
                        <td>
                            <CInput addInputClasses="small" v-model="item.name" />
                        </td>
                    </template>

                    <template #unitPrice-header>
                        {{ $t('conversion.unit_price') }}<span class="text-danger">*</span>
                    </template>
                    <template #unitPrice="{item}">
                        <td class="ltr">
                            <CInput addInputClasses="small" type="number" v-model="item.unit_price" />
                        </td>
                    </template>

                    <template #quantity-header>
                        {{ $t('conversion.quantity') }}<span class="text-danger">*</span>
                    </template>
                    <template #quantity="{item}">
                        <td class="ltr">
                            <CInput addInputClasses="small" type="number" v-model="item.quantity" />
                        </td>
                    </template>

                    <template #totalPrice-header>
                        {{ $t('conversion.total_price') }}<span class="text-danger">*</span>
                    </template>
                    <template #totalPrice="{item}">
                        <td class="ltr">
                            <CInput addInputClasses="small" type="number" v-model="item.total_price" />
                        </td>
                    </template>
                </CDataTable>
            </CRow>
        </CRow>

        <CButton :disabled="invalid || filteredProducts.length == 0" type="submit"  color="primary" class="px-4 mfs-auto d-block">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { userService } from '@/services/api'
import { StoreUserRelationStatus } from '@/constants'

export default {
    name: 'CreateForm',

    props: {
        submitForm: {
            default: () => {},
        },
        stores: {},
    },

    data() {
        return {
            users: [],
            productsFields: [
                {
                    key: 'pid',
                    label: this.$t('attributes.id'),
                    _style: 'width: 10%',
                },
                {
                    key: 'name',
                    _style: 'width: 30%',
                },
                {
                    key: 'unitPrice',
                },
                {
                    key: 'quantity',
                },
                {
                    key: 'totalPrice',
                },
            ],
            conversion: {
                store_id: '',
                user_id: '',
                order_id: '',
                amount: '',
                type: 'sale',
                coupon: null,
                products: [
                    {
                        pid: '',
                        name: '',
                        unit_price: '',
                        quantity: '',
                        total_price: '',
                    },
                ],
            }
        }
    },

    computed: {
        filteredProducts() {
            return this.conversion.products.filter(
                product => product.name.length > 0 && product.unit_price > 0 && product.quantity > 0 && product.total_price > 0
            )
        },
    },

    watch: {
        'conversion.store_id'(val) {
            if (val) {
                this.fetchUsers()
            }
        }
    },

    methods: {
        submitLocal() {
            let data = {
                order_id: this.conversion.order_id,
                amount: this.conversion.amount,
                type: this.conversion.type,
                coupon: this.conversion.coupon || null,
                store_id: this.conversion.store_id ? this.conversion.store_id.value : null,
                user_id: this.conversion.user_id ? this.conversion.user_id.value : null,
            }
            data['products'] = this.filteredProducts

            this.submitForm(data)
        },
        addProductRow() {
            this.conversion.products.push({
                name: '',
                unit_price: '',
                quantity: '',
                total_price: '',
            })
        },
        fetchUsers() {
            const storeId = this.conversion.store_id ? this.conversion.store_id.value : 0
            if (!storeId) {
                this.users = []
                this.conversion.user_id = ''
                return
            }

            userService.fetch({
                no_paginate: true,
                just: ['id', 'first_name', 'last_name'],
                store_users: {
                    store_id: storeId,
                    status: StoreUserRelationStatus.ACTIVE
                }
            }).then(res => res.data.data).then(result => this.users = Object.keys(result).map((id) => {
                return {
                    value: result[id].id,
                    label: result[id].first_name + ' ' + result[id].last_name,
                }
            }))
        },
    },
}
</script>